/* import __COLOCATED_TEMPLATE__ from './seller-posting.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import clsx from 'clsx';

const CLASS_NAME = 'seller-posting';
const FULL_CLASS_NAME = `${CLASS_NAME}--full`;

export default class SellerPostingComponent extends Component {
  @service('commands.assignment-commands') assignmentCommandService;
  @service session;

  get className() {
    return clsx(
      CLASS_NAME,
      this.args.full && FULL_CLASS_NAME,
    );
  }

  @action
  initializeData() {
    this.args.markViewed(this.args.assignment);
    this.assignmentCommandService.trackUserView(this.args.assignment.id, this.session.currentUser.id);
  }
}
